export const MAIL_TO_ROBIN = "mailto:robin@mimbly.se";
export const CALL_TO_ROBIN = "tel:070 291 10 09";
